import styles from "../styles/Home.module.css"
import Login from "../components/Login"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { useUser } from "../hooks/useUser"

export default function Home() {
    const { user, userLoading } = useUser()
    const router = useRouter()
    const signUp = !!router.query?.signUp

    const linkWithAcc = router.query

    // Listen for changes on loading and authUser, redirect if needed
    const [checkedUserOnArrival, setCheckedUserOnArrival] = useState(false)
    useEffect(() => {
        if (!userLoading && !checkedUserOnArrival) {
            if (user?.uid) {
                // router.push("/videos/create")
            }
            setCheckedUserOnArrival(true)
        }
    }, [router, user, userLoading])

    return (
        <div className="w-screen h-screen bg-twitter-500 flex place-content-center">
            <Login defaultSigningUp={signUp} />
        </div>
    )
}
